import React from 'react';
import { WarningDiamond } from './Icons';
import type { Props } from './Input';
import styles from './Input.module.scss';
import InputDecorator from './InputDecorator';

interface InputValidationProps {
  children: React.ReactElement<Props>;
  validationError?: string;
  style?: React.CSSProperties;
}

/**
 * Wraps an `Input` with a validation message and infers `hasValidationError`.
 */
export const InputValidation = ({ children, validationError, style }: InputValidationProps) => {
  const hasValidationError = !!validationError;
  const inputWithProps = React.cloneElement(children, { hasValidationError });
  return (
    <>
      <InputDecorator
        suffix={hasValidationError && <WarningDiamond className={styles.validationErrorIcon} />}
      >
        {inputWithProps}
      </InputDecorator>
      {hasValidationError && (
        <div className={styles.validationErrorText} style={style}>
          {validationError}
        </div>
      )}
    </>
  );
};
